import React, { useState, useEffect } from 'react';
import { api } from '../utils/api';
import { Shield, FileText, Clock } from 'lucide-react';

export const Policies = () => {
  const [policies, setPolicies] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadPolicies();
  }, []);

  const loadPolicies = async () => {
    try {
      const data = await api.get('/api/policies');
      setPolicies(data);
    } catch (error) {
      console.error('Error loading policies:', error);
    } finally {
      setLoading(false);
    }
  };

  const getPolicyIcon = (type) => {
    switch (type) {
      case 'privacy': return <Shield className="h-6 w-6" />;
      case 'terms': return <FileText className="h-6 w-6" />;
      default: return <Clock className="h-6 w-6" />;
    }
  };

  return (
    <div className="min-h-screen bg-background py-12" data-testid="policies-page">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h1 className="text-4xl sm:text-5xl font-display font-bold text-primary mb-4">
            Políticas e Termos
          </h1>
          <p className="text-text-secondary">
            Transparência e segurança em todas as nossas operações
          </p>
        </div>

        {loading ? (
          <div className="text-center py-12">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto"></div>
          </div>
        ) : (
          <div className="space-y-6">
            {policies.map((policy) => (
              <div
                key={policy.id}
                className="bg-white p-8 rounded-xl shadow-lg"
                data-testid={`policy-${policy.type}`}
              >
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center text-primary flex-shrink-0">
                    {getPolicyIcon(policy.type)}
                  </div>
                  <div className="flex-1">
                    <h2 className="text-2xl font-display font-semibold text-primary mb-3 capitalize">
                      {policy.type === 'privacy' ? 'Privacidade (LGPD)' :
                       policy.type === 'terms' ? 'Termos de Uso' :
                       policy.type === 'cancellation' ? 'Política de Cancelamento' :
                       policy.type === 'checkin' ? 'Check-in' :
                       policy.type === 'checkout' ? 'Check-out' : policy.type}
                    </h2>
                    <p className="text-text-secondary leading-relaxed">
                      {policy.description}
                    </p>
                  </div>
                </div>
              </div>
            ))}

            {policies.length === 0 && (
              <div className="bg-white p-8 rounded-xl shadow-lg text-center text-text-secondary">
                Nenhuma política encontrada.
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};
